import { Checkbox } from '@mui/material'
import { BasicInputField } from 'cwp-components/forms'
import { useState } from 'react'

export const Newsletter = () => {
  const [hasAgreed, setHasAgreed] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')

  const joinNewsletter = async (data) => {
    const res = await fetch(
      'https://staging.api.legalutopia.co.uk/api/v1/website/subscribe-newsletter/',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          'first_name': data.firstName,
          'last_name': data.lastName,
          'email': email,
        }),
      },
    )
    if (!res.ok) {
      console.error('Failed to subscribe to the newsletter')
    } else {
      console.error('Subscribed to the newsletter')
    }
  }

  const handleJoinNewsletter = () => {
    joinNewsletter({ firstName, lastName, email })
  }

  return (
    <div className='md:m-[300px_0px_80px] m-[80px_0px_60px] flex justify-center'>
      <div className='md:w-[1350px] w-full md:p-[80px] p-[40px_24px] rounded-[20px] bg-[#EBF3FF] max-sm:mx-[20px]'>
        <h1 className='md:text-[64px] text-[24px] font-bold text-[#020251] text-center '>
          Join our newsletter
        </h1>
        <p className='md:text-[24px] text-text-muted m-[24px_0px_40px] text-center '>
          Get updates on the latest insights, podcasts, and more via our
          newsletter.
        </p>
        <div className='flex flex-col'>
          <div className='mx-auto'>
            <div className='flex flex-col gap-3'>
              <BasicInputField
                label='First name'
                className='md:w-[455px]'
                placeholder='First name'
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <BasicInputField
                label='Last name'
                className='md:w-[455px]'
                placeholder='Last name'
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <BasicInputField
                label='Email address'
                className='md:w-[455px]'
                placeholder='Email address'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className='ml-[-10px] max-sm:text-[12px] md:mt-[20px] flex items-center'>
              <Checkbox
                value={hasAgreed}
                onChange={() => setHasAgreed(!hasAgreed)}
                className=''
              />
              <span>
                I agree to the{' '}
                <a href='' className='underline'>
                  Privacy policy
                </a>{' '}
                and{' '}
                <a href='' className='underline'>
                  Marketing policy
                </a>
              </span>
            </div>
            <div className='mt-5 flex justify-end'>
              <button
                disabled={!(hasAgreed && firstName && lastName && email)}
                onClick={handleJoinNewsletter}
                className='rounded-md pl-3 pr-3 pt-1.5 pb-1.5 font-medium leading-tight tracking-wide shadow-md bg-[#020251] text-white disabled:bg-[#f4f4f4] disabled:text-[#A0ABBE]'
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
